import * as React from 'react';
import {emotionStyled, tokens} from '@packages/utilities/styled';
import {Webhooks20, Webhooks12} from '@packages/systems/ui/icons';

const IconWrapper = emotionStyled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: tokens.colors.actionPrimaryBackground,
  width: '100%',
  height: '100%',
});

export const webhookIcons = {
  Webhooks: Webhooks12,
  WebhooksDetail: () => (
    <IconWrapper>
      <Webhooks20 />
    </IconWrapper>
  ),
} as const;
